/**
 * Threedium platform host (homepage / dashboard), inferred from agents env.
 *
 * Frontend has no THREEDIUM_ENV. QE vs prod is visible on
 * REACT_APP_PUBLISH_DOMAIN (e.g. agents-mvp-qe.threedium.io) and the
 * agents hostname. Local builds usually keep the QE publish domain.
 */
export function getThreediumPlatformOrigin() {
  const publishDomain = (process.env.REACT_APP_PUBLISH_DOMAIN || '').toLowerCase();
  const host = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  const hint = `${publishDomain} ${host}`;

  if (hint.includes('staging')) {
    return 'https://staging.threedium.io';
  }
  if (hint.includes('qe')) {
    return 'http://qe.threedium.io';
  }
  if (
    host === 'localhost'
    || host === '127.0.0.1'
    || publishDomain.includes('localtest')
    || !publishDomain
  ) {
    return 'http://qe.threedium.io';
  }
  return 'https://threedium.io';
}

export function getThreediumPlanUpgradeUrl() {
  return `${getThreediumPlatformOrigin()}/dashboard?popup=planUpgrade`;
}
